module.exports = __webpack_public_path__ + "static/media/DVI4_EDITSINGLE.390e1651.mp4";